import React, { useState } from "react";
import DataTable from "../../components/DataTable";
import PageWrapperForm from "../../components/PageWrapperForm";
import { useTableDataWithPost } from "../../hooks/useTableWithPost";
import { BannerManagementConfig } from "../../config/tableConfigs";
import BannerFormModal from "./components/BannerFormModal";
import DeleteModal from "../../components/DeleteModal";
import { useSession } from "hooks/useSession";

const BannerManagementPage = () => {
  const [modalShow, setModalShow] = useState(false);
  const [modalMode, setModalMode] = useState("add");
  const [selectedBanner, setSelectedBanner] = useState(null);
  const [refresh, setRefresh] = useState(0);
  const { userid } = useSession();

  const handleAddBanner = () => {
    setModalMode("add");
    setSelectedBanner(null);
    setModalShow(true);
  };
const formdata = new FormData();
  formdata.append("action", "GET");        // ✅ action field
  formdata.append("company", userid); 
  // ✅ GET uses query param ?company=  (matches request.GET.get("company"))
  const tableData = useTableDataWithPost(
    `https://pro.mokshiq.in/banner_management`,
    BannerManagementConfig,
    formdata,     // no POST body needed — it's a GET request
    refresh
  );

  const handleView = (banner) => {
    console.log("Viewing banner:", banner);
  };

  const handleEditBanner = (banner) => {
    setModalMode("edit");
    setSelectedBanner(banner);
    setModalShow(true);
  };

  const handleDelete = (banner) => {
    setSelectedBanner(banner);
    setTimeout(() => {
      const modalEl = document.getElementById("deletebanner1");
      if (modalEl) {
        const modal = window.bootstrap.Modal.getOrCreateInstance(modalEl);
        modal.show();
      }
    }, 100);
  };

  const handleExport = (selectedIds) => {
    alert(`Exporting ${selectedIds.length} selected records`);
  };

  const handleDeleteSelected = (selectedIds) => {
    if (window.confirm(`Are you sure you want to delete ${selectedIds.length} records?`)) {
      setRefresh((prev) => prev + 1);
    }
  };

  const handleFormSuccess = () => {
    setRefresh((prev) => prev + 1);
    setModalShow(false);
  };

  const handleDeleteSuccess = () => {
    setRefresh((prev) => prev + 1);
  };

  return (
    <main>
      <div className="container-fluid">
        {/* Custom Header Layout */}
        <div className="row m-1 mb-4">
          <div className="col-12 d-flex justify-content-between align-items-center">
            <div>
              <h4 className="main-title fw-bold" style={{ color: "#1a1a1a", fontSize: "1.8rem", marginBottom: "4px" }}>Banner Management</h4>
              <div className="d-flex align-items-center gap-2 mb-0" style={{ fontSize: "13.5px", fontWeight: "500" }}>
                <a href="#" className="text-decoration-none" style={{ color: "#7e57c2", display: "flex", alignItems: "center" }}>
                  <i className="ph-duotone ph-image f-s-16"></i> <span className="ms-1">Banner</span>
                </a>
                <span style={{ color: "#a0a5b1" }}>/</span>
                <a href="#" className="text-decoration-none" style={{ color: "#7e57c2" }}>
                  Management
                </a>
              </div>
            </div>

            <div>
              <button
                className="btn btn-primary d-flex align-items-center justify-content-center px-4"
                onClick={handleAddBanner}
                style={{
                  backgroundColor: "#7e57c2", borderColor: "#7e57c2", borderRadius: "8px", height: "44px", width: "fit-content", minWidth: "160px"
                }}
              >
                <i className="iconoir-plus-circle me-2" style={{ fontSize: "20px" }}></i>
                <span className="fw-medium text-nowrap">Add Banner</span>
              </button>
            </div>
          </div>
        </div>

        {/* Card Body */}
        <div className="row m-1">
          <div className="col-12">
            <div className="card border-0" style={{ borderRadius: "12px", boxShadow: "0 2px 12px rgba(0,0,0,0.04)" }}>
              <div className="card-body p-4">
                <DataTable
                  config={BannerManagementConfig}
                  tableData={tableData}
                  onView={handleView}
                  onEdit={handleEditBanner}
                  onDelete={handleDelete}
                  onExport={handleExport}
                  onDeleteSelected={handleDeleteSelected}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <BannerFormModal
        show={modalShow}
        onClose={() => setModalShow(false)}
        mode={modalMode}
        userData={selectedBanner}   // has: { name, photo, type } from GET
        onSuccess={handleFormSuccess}
      />

     <DeleteModal
        deleteid={selectedBanner?.id}
        id="deletebanner1"
        title="Delete Banner"
        message="Are you sure you want to delete this banner?"
        apiUrl="https://pro.mokshiq.in/banner_management"
        deleteKey="banner_id"          // ✅ field name sent to API
        action="DELETE"                // ✅ action field
        onSuccess={handleDeleteSuccess}
    />
    </main>
  );
};

export default BannerManagementPage;